import React from "react";

import List from "./list";
import Form from "./form";
import Show from "./show";
import Receivable from "./receivable";
import ReceivableXTM from "./receivableXtm";

import { Switch, Route, Redirect } from "react-router-dom";
import {
    LAYOUT_MANAGER_QUOTE_LIST,
    LAYOUT_MANAGER_QUOTE_NEW,
    LAYOUT_MANAGER_QUOTE_EDIT,
    LAYOUT_MANAGER_QUOTE_SHOW,
    LAYOUT_MANAGER_QUOTE_EMAIL,
    LAYOUT_MANAGER_QTASK_RECEIVABLE_SALESFORCE,
    LAYOUT_MANAGER_QTASK_RECEIVABLE_XTM,
} from "../navigation";

const Connector = (props) => (
    <>
        <Switch>
            <Route path={LAYOUT_MANAGER_QUOTE_LIST} render={(routeProps) => <List {...props} {...routeProps} />} />

            <Route path={LAYOUT_MANAGER_QUOTE_NEW} render={(routeProps) => <Form alta {...props} {...routeProps} />} />
            <Route
                path={LAYOUT_MANAGER_QUOTE_EDIT(":id")}
                render={(routeProps) => <Form {...props} {...routeProps} />}
            />
            <Route
                path={LAYOUT_MANAGER_QUOTE_SHOW(":id")}
                render={(routeProps) => <Show {...props} {...routeProps} />}
            />
            <Route
                path={LAYOUT_MANAGER_QTASK_RECEIVABLE_SALESFORCE(":id")}
                render={(routeProps) => <Receivable {...props} {...routeProps} />}
            />
            <Route
                path={LAYOUT_MANAGER_QTASK_RECEIVABLE_XTM(":id")}
                render={(routeProps) => <ReceivableXTM {...props} {...routeProps} />}
            />

            <Redirect to={LAYOUT_MANAGER_QUOTE_LIST} />
        </Switch>
    </>
);

export default Connector;

{
    /*
     */
}
